export enum LabelTypes {
  Primary,
  Secondary,
}
